// extracted by mini-css-extract-plugin
export default {"coustomScrollBar":"soil_coustomScrollBar__a5pO9"};